import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Table, Card, Button, Tag, Typography, Row, Col, 
  Space, Popconfirm, message 
} from 'antd';
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from '@ant-design/icons';
import { clienteService } from '../../services/api';

const { Title } = Typography;

const ClientesList = () => {
  const [loading, setLoading] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    fetchClientes();
  }, [pagination.current]);

  const fetchClientes = async () => {
    setLoading(true);
    try {
      const response = await clienteService.getAll({
        page: pagination.current,
        per_page: pagination.pageSize,
      });
      setClientes(response.data.clientes);
      setPagination(prev => ({
        ...prev,
        total: response.data.total,
      }));
    } catch (error) {
      message.error('Error al cargar clientes');
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    try {
      await clienteService.delete(id);
      message.success('Cliente eliminado');
      fetchClientes();
    } catch (error) {
      message.error(error.response?.data?.error || 'Error al eliminar');
    }
  };

  const handleTableChange = (pag) => {
    setPagination(prev => ({
      ...prev,
      current: pag.current,
    }));
  };

  const columns = [
    {
      title: 'Razón Social',
      dataIndex: 'razon_social',
      key: 'razon_social',
    },
    {
      title: 'CUIT',
      dataIndex: 'cuit',
      key: 'cuit',
    },
    {
      title: 'Email',
      dataIndex: 'email_contacto',
      key: 'email_contacto',
    },
    {
      title: 'Localidad',
      dataIndex: 'localidad',
      key: 'localidad',
    },
    {
      title: 'Estado',
      key: 'estado',
      render: (_, record) => (
        <Tag color={record.estado_cliente === 1 ? 'green' : 'red'}>
          {record.estado_cliente === 1 ? 'Activo' : 'Inactivo'}
        </Tag>
      ),
    },
    {
      title: 'Acciones',
      key: 'actions',
      width: 150,
      render: (_, record) => (
        <Space size="small">
          <Button 
            type="text" 
            icon={<EyeOutlined />} 
            onClick={() => navigate(`/clientes/${record.id_clientes}`)}
          />
          <Button 
            type="text" 
            icon={<EditOutlined />} 
            onClick={() => navigate(`/clientes/${record.id_clientes}/editar`)}
          />
          <Popconfirm
            title="¿Eliminar este cliente?"
            onConfirm={() => handleDelete(record.id_clientes)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="text" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Title level={2} style={{ margin: 0 }}>Clientes</Title>
        </Col>
        <Col>
          <Button 
            type="primary" 
            icon={<PlusOutlined />}
            onClick={() => navigate('/clientes/nuevo')}
          >
            Nuevo Cliente
          </Button>
        </Col>
      </Row>

      <Card>
        <Table
          scroll={{ x: 'max-content' }}
          columns={columns}
          dataSource={clientes}
          rowKey="id_clientes"
          loading={loading}
          pagination={{
            ...pagination,
            showSizeChanger: true,
            showTotal: (total) => `Total: ${total} clientes`,
          }}
          onChange={handleTableChange}
        />
      </Card>
    </div>
  );
};

export default ClientesList;
